import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { ContentTabs, Emblem, BtnSet, Loader, PublicationPreview, VideoBox } from '../Atoms'
import Info from './Info'
import Events from './Events'
import Rosters from './Rosters'
import Stats from './Stats'

import { injectQueryPath } from '../../utils'

import axios from 'axios'
import { ENDPOINT } from '../../env'
import moment from 'moment'
import qs from 'qs'

import Lightbox from 'yet-another-react-lightbox'

import 'yet-another-react-lightbox/styles.css'
import './style.scss'

import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import 'yet-another-react-lightbox/plugins/thumbnails.css'

import DesktopContext from '../../Layouts/Desktop/ctx'
import {CONF} from "../../configs";

const tabs = [
    {label: 'Инфо', id: 'info', icon: 'pi pi-info-circle', component: Info},
    {label: 'События', id: 'events', icon: 'pi pi-bolt', component: Events},
    {label: 'Составы', id: 'rosters', icon: 'pi pi-list', component: Rosters},
    {label: 'Статистика', id: 'stats', icon: 'pi pi-chart', component: Stats}
]

const Match = ({ theme, width, layout }) => {
    const [data, setData] = useState(null)
    const [tab, setTab] = useState(0)
    const [videoBoxItem, setVideoBoxItem] = useState(null)
    const [gallery, setGallery] = useState(null)
    const [galleryIndex, setGalleryIndex] = useState(-1)
    const [useProxy, setUseProxy] = useState(false)
    const [proxyData, setProxyData] = useState(null)
    const [statsData, setStatsData] = useState(null)

    const { id } = useParams()
    const history = useHistory()
    const location = useLocation()

    const ctx = useContext(DesktopContext)

    const query = useMemo(() => qs.parse(location.search.slice(1)), [location.search])
    const pubId = query.publication

    const clearPublicationFromUrl = useCallback(() => {
        const cleanQuery = Object.keys(query).reduce((acc, k) => {
            if(k !== 'publication') acc[k] = query[k]
            return acc
        }, {})
        const newSearch = Object.keys(cleanQuery).length ? `?${qs.stringify(cleanQuery)}` : ''
        history.replace(`${location.pathname}${newSearch}`)
        ctx?.setPublicationId?.(null)
    }, [query, location.pathname, history, ctx])

    useEffect(() => {
        if(!id) return
        axios.get(`${ENDPOINT}client/matchinfo/${id}?full=true`)
            .then(resp => {
                if(!resp.data) return
                setData(resp.data)
                if(resp.data.scores?.full) {
                    setTab(1)
                    if(resp.data.statsData?.length) setStatsData(resp.data.statsData)
                } else if(resp.data.matchday?.originDate === moment().format('YY-MM-DD')) {
                    setUseProxy(true)
                }
            })
    }, [id])

    useEffect(() => {
        if(!data?.publications || !pubId || videoBoxItem) return
        
        const pub = data.publications.find(p => p._id === pubId)
        if(!pub) return

        if(pub.mediaType === 'video') {
            setVideoBoxItem(pub)
            clearPublicationFromUrl()
        } else if((pub.mediaType === 'mixed' || pub.type === 'mixed')) {
            axios.get(`${ENDPOINT}client/publication/${pubId}`)
                .then(resp => {
                    if(resp.data?.attachments?.some(att => att.type === 'video')) {
                        setVideoBoxItem({...pub, mediaType: 'video'})
                        clearPublicationFromUrl()
                    }
                })
        }
    }, [data, pubId, videoBoxItem, clearPublicationFromUrl])

    useEffect(() => {
        if(!useProxy || !id) return
        const proxyInterval = setInterval(() => {
            axios.get(`${ENDPOINT}client/stateproxy/${id}`)
                .then(resp => {
                    if(resp.data) {
                        setProxyData(resp.data)
                        if(resp.data.statsData?.length) setStatsData(resp.data.statsData)
                    }
                })
        }, 10000)
        return () => clearInterval(proxyInterval)
    }, [useProxy, id])

    const linkHandle = useCallback((event) => {
        event.preventDefault()
        history.push(event.currentTarget.getAttribute('href'))
    }, [history])

    const Specified = tabs[tab].component

    const handlePublicationOpen = useCallback((pub, galleryData) => {
        if(pub.mediaType === 'video') {
            setVideoBoxItem(pub)
        } else if(pub.mediaType === 'album') {
            setGallery(galleryData)
            setGalleryIndex(0)
        } else {
            history.push(`${window.location.pathname}${injectQueryPath('publication', pub._id)}`)
            ctx?.setPublicationId?.(pub._id)
        }
    }, [history, ctx])

    const score = useMemo(() => {
        if(!data) return { home: '-', away: '-' }
        const full = data.scores?.full
        if(full) return { home: full.home, away: full.away }
        if(proxyData?.time?.score) return proxyData.score
        return { home: '-', away: '-' }
    }, [data, proxyData])

    const scoreNode = data && (
        <div className='match-main_score'>
            {proxyData?.time != null && (
                <div className='state-indicator'>
                    <i></i>
                    <span>{proxyData.finished ? 'завершён' : !proxyData.time.active ? 'перерыв' : `идёт ${proxyData.time.displayMinute} минута`}</span>
                </div>
            )}
            <div className='match-main_score_cell alterfont'>{score.home}</div>
            <div className='match-main_score_cell alterfont'>{score.away}</div>
            {(() => {
                const hasShootout = data.scores?.shootout && 
                    (data.scores.shootout.home != null || data.scores.shootout.away != null) && 
                    (data.scores.shootout.home !== 0 || data.scores.shootout.away !== 0)
                return hasShootout ? (
                    <div className='shootout'>{`по пенальти: ${data.scores.shootout.home}:${data.scores.shootout.away}`}</div>
                ) : null
            })()}
        </div>
    )

    const homeTeamNode = data && (
        <a href={`/club/${data.home.club._id}?team=${data.home._id}`} className='match-main_team __home' onClick={linkHandle}>
            <Emblem backdroped={true} size='md' source={data.home.emblem || data.home.club.emblem} />
            <div className='match-team_name alterfont'>{data.home.name}</div>
        </a>
    )

    const awayTeamNode = data && (
        <a href={`/club/${data.away.club._id}?team=${data.away._id}`} className='match-main_team __away' onClick={linkHandle}>
            <Emblem backdroped={true} size='md' source={data.away.emblem || data.away.club.emblem} />
            <div className='match-team_name alterfont'>{data.away.name}</div>
        </a>
    )

    return  data ? <div
                className={`match ${layout}`}
                style={{
                    //width: width,
                    backgroundColor: theme.surface.includes('#') ? theme.surface : `var(--${theme.surface})`
                }}
            >
                <Helmet>
                    <title>{`Матч ${data.home.name} 🆚 ${data.away.name} | ${data.matchday.date} | ${CONF.appTitle}`}</title>
                </Helmet>

                <div className='container'>
                    <div className='primary'>
                        {layout === 'mobile' ? (
                            <div className='match-main'>
                                {scoreNode}

                                <div className='match-main_teams'>
                                    {homeTeamNode}
                                    {awayTeamNode}
                                </div>

                                <ContentTabs
                                    width={layout === 'mobile' ? width : '100%'}
                                    layout={layout}
                                    theme='blue'
                                    model={tabs}
                                    activeIdx={tab}
                                    onChange={e => setTab(e.index)}
                                />
                            </div>
                        ) : (
                            <div className='match-main'>
                                <div>
                                    <div className='match-main_teams'>{homeTeamNode}</div>
                                    {scoreNode}
                                    <div className='match-main_teams'>{awayTeamNode}</div>
                                </div>

                                {ctx.bannerNode}

                                <div className='match-btn_set'>
                                    <BtnSet
                                        theme='bluegray-50'
                                        darken='bluegray-400'
                                        size='sm'
                                        btns={statsData ? [
                                            {id: 'info', label: 'Информация', icon: 'info-circle'},
                                            {id: 'events', label: 'События', icon: 'bolt'},
                                            {id: 'rosters', label: 'Составы', icon: 'list'},
                                            {id: 'stats', label: 'Статистика', icon: 'chart'}
                                        ] : [
                                            {id: 'info', label: 'Информация', icon: 'info-circle'},
                                            {id: 'events', label: 'События', icon: 'bolt'},
                                            {id: 'rosters', label: 'Составы', icon: 'list'}
                                        ]}
                                        active={tabs[tab].id}
                                        onChange={id => setTab(tabs.findIndex(t => t.id === id))}
                                    />
                                </div>
                            </div>
                        )}

                        <div className='match-content'>
                            <Specified data={data} matchId={id} proxyData={proxyData} statsData={statsData} />
                        </div>
                    </div>

                    <div className='secondary'>
                        {data.publications?.map(pub => (
                            <div className='match-publication' key={pub._id}>
                                <PublicationPreview
                                    data={pub}
                                    onOpen={galleryData => handlePublicationOpen(pub, galleryData)}
                                />
                            </div>
                        ))}
                    </div>

                    <VideoBox
                        data={videoBoxItem}
                        key={videoBoxItem?._id}
                        onClose={() => setVideoBoxItem(null)}
                    />

                    <Lightbox
                        slides={gallery}
                        open={galleryIndex >= 0}
                        index={galleryIndex}
                        close={() => {
                            setGalleryIndex(-1)
                            setGallery(null)
                        }}
                        plugins={[Thumbnails, Zoom]}
                    />
                </div>
            </div> : (
                <div className='match-loader'>
                    <Loader width={180} />
                </div>
            )
}

export default Match
